/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from "react";
import {t} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {connect} from 'react-redux';
import {Form, Modal, Input, message} from 'antd';
import TransactionActions from "bukku/redux/Transaction/actions";
import ListMenu from "../index";
import {getMsgType, getMsgTypeCapitalized, Type} from "bukku/redux/Transaction/helper";
import {getOptions} from "./options";
import { createListManager } from '../../../redux/List/helper';
import { L } from '../../../redux/List/reducer';
import { SubscriptionScopeKey } from '../../Access/helper/subscription/enum/SubscriptionScopeKey';
// import { SubscriptionCheck } from '../../Access/helper/subscription/SubscriptionCheck';
import { getTransactionInitStatus } from "../../SubmitFooter/helper";
import {
    getReorderedFormDesign,
} from "../../../containers/AppPage/ControlPanel/Settings/PaneFormDesign.helper";
import {getPrintUrl} from "../../../redux/Transaction/helpers/getPrintUrl";
import {TransactionUrl} from "../../../redux/Transaction/helpers/TransactionUrl";
import { onTransactionTableRowClick } from "../../Table/Transaction/onTransactionTableRowClick";
import Hotkeys from "react-hot-keys";
import { PermissionSubscriptionCheck } from "../../Access/helper/PermissionSubscriptionCheck";
import { PermissionV2 } from "../../Access/helper/permission/enum/PermissionV2";
import { AccessHelper } from "../../Access/helper/helper";
import { MyInvoisTransactionHelper } from "../../../helpers/MyInvoisTransactionHelper";

const {
    transactionUpdateStatus,
    transactionDelete,
    transactionTableOnRowClick,
    transactionTableAfterRowClick,
} = TransactionActions;

class TransactionListMenu extends Component {
    constructor(props) {
        super(props);
        const { type } = this.props;

        const option = getOptions(type);
        if (option.print)
            createListManager([L.settings, L.form_designs]).readLists();

        this.formRef = React.createRef();

        // this.hasMultiFormDesignSubscription =
        //     SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_FORM_DESIGN).hasSubscriptionTo();
        this.inputRef = React.createRef();

        this.state = {
            modalOpen: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            modalOpen,
        } = this.state;
        const {
            transactionTableOnRowClickId,
        } = this.props;

        if (transactionTableOnRowClickId &&
            transactionTableOnRowClickId === this.rowItem?.id)
            onTransactionTableRowClick(this.props, this.rowItem);

        if (modalOpen && !prevState.modalOpen) {
            setTimeout(() => {
                this.inputRef.current.focus();
            }, 100);
        }
    }

    componentWillUnmount() {
        const {
            transactionTableAfterRowClick,
        } = this.props;

        transactionTableAfterRowClick();
    }

    getStatusText = status => {
        switch (status) {
            case 'ready':
                return t`Ready`;
            case 'pending_approval':
                return t`Pending Approval`;
            case 'void':
            default:
                return t`Void`;
        }
    };

    handleUpdateTransactionStatus = (id, status, transactionModal) => {
        const { type, transactionUpdateStatus, record } = this.props;

        const void_reason = this.formRef.current?.getFieldsValue().void_reason || null;

        const voidReasonRequired = record.myinvois_action === 'VALIDATE' && record.myinvois_document_status === 'VALID' && status === 'void';

        if (voidReasonRequired) {
            this.formRef.current?.validateFields().then(() => {
                transactionUpdateStatus(type, id, { status, send_email: false, void_reason });
                this.setState({modalOpen: false});
                transactionModal.destroy();

                return true;
            }).catch(() => {
                message.warning(t`Please check for fields / items highlighted in red.`);
            });
        }
        else {
            transactionUpdateStatus(type, id, { status, send_email: false, void_reason });
            this.setState({modalOpen: false});
            transactionModal.destroy();

            return true;
        }

        return null;
    };

    updateTransactionStatus = (id, status) => {
        const { type, record, companyCountryCode, settings } = this.props;
        const statusText = this.getStatusText(status);
        const name = getMsgType(type);

        const hasLinkItems = type === Type.sale_credit_note || type === Type.purchase_credit_note ||
                             type === Type.sale_payment || type === Type.purchase_payment ||
                             type === Type.sale_refund || type === Type.purchase_refund;

        const transactionModal = Modal.confirm();

        this.setState({modalOpen: true});
        const _this = this;

        const isMalaysianCompany = companyCountryCode === 'MY';

        const voidReasonRequired = record.myinvois_action === 'VALIDATE' && record.myinvois_document_status === 'VALID' && status === 'void';
        const showMyInvoisWarning = [
            Type.sale_invoice,
            Type.sale_credit_note,
            Type.purchase_credit_note,
            Type.purchase_bill,
            Type.purchase_bill_cash,
            Type.purchase_bill_claim,
        ].includes(type) && status === 'void' && voidReasonRequired &&
        isMalaysianCompany && settings.is_myinvois_submission_enabled;

        const voidContent = (
            <Hotkeys
                keyName="enter,esc"
                onKeyDown={keyName => {
                    switch (keyName) {
                        case "enter":
                            this.handleUpdateTransactionStatus(id, status, transactionModal);
                            return true;
                        case "esc":
                            _this.setState({modalOpen: false});
                            return false;
                        default:
                            return false;
                    }
                }}
                filter={() => true}
            >
                <span style={{whiteSpace: 'pre-line'}}>
                    {[
                        t`Do you really want to mark the ${name} as ${statusText}?`,
                        type === Type.contra ? t`All applied amounts between invoices and bills will be cleared.` : null,
                        hasLinkItems ? t`Amount applied to other transactions will be cleared.` : null,
                        showMyInvoisWarning ? t`The transaction will be cancelled with MyInvois.` : null,
                    ].filter(text => !!text).join('\n')}
                </span>
                <br />
                <br />
                <Form ref={this.formRef} layout="vertical">
                    <Form.Item
                        label={t`Note:`}
                        name="void_reason"
                        rules={[{
                            required: voidReasonRequired,
                            message: t`Void reason is required.`,
                        }]}
                        initialValue={
                            record.reject_message ? `Customer provided reason: ${record.reject_message}` : null
                        }
                    >
                        <Input
                        // autofocus issue: https://github.com/ant-design/ant-design/issues/8668
                            ref={input => {
                                if (input)
                                    this.inputRef.current = input;
                            }}
                            maxLength={255}
                            placeholder="Created by mistake"
                        />
                    </Form.Item>
                </Form>
            </Hotkeys>
        );

        transactionModal.update({
            title: t`Mark as ${statusText}`,
            content: status === 'void' ?
                voidContent :
                t`Do you really want to mark the ${name} as ${statusText}?`,
            onOk: close => {
                if (this.handleUpdateTransactionStatus(id, status, transactionModal))
                    close();
                // _this.setState({modalOpen: false});
            },
            onCancel() {
                _this.setState({modalOpen: false});
            },
            okText: t`OK`,
            cancelText: t`Cancel`,
        });
    };

    voidTransaction = id => {
        this.updateTransactionStatus(id, 'void');
    };

    unvoidTransaction = id => {
        this.updateTransactionStatus(id, 'ready');
    };

    deleteTransaction = id => {
        const { type, transactionDelete } = this.props;
        const name = getMsgType(type);

        const capitalizedName = name
            .split(' ')
            .map(word => word[0].toUpperCase() + word.substring(1))
            .join(" ");

        Modal.confirm({
            title: t`Delete ${capitalizedName}`,
            content: t`Do you really want to delete the ${name}?`,
            onOk() {
                transactionDelete(type, id);
            },
            onCancel() { },
            okText: t`OK`,
            cancelText: t`Cancel`,
        });
    };

    addPaymentsRefunds = (toType, fromType, id, items) => {
        const url = TransactionUrl.pay(toType, fromType, id);

        switch (toType) {
            case Type.sale_refund:
            case Type.purchase_refund:
                items.push({
                    key: 'add-refund',
                    label: t`Add Refund`,
                    url,
                    isCreate: true,
                });
                break;
            case Type.sale_payment:
            case Type.purchase_payment:
            default:
                items.push({
                    key: 'add-payment',
                    label: t`Add Payment`,
                    url,
                    isCreate: true,
                });
                break;
        }
    };

    getApplicableUpdateStatuses = highestStatusAccess => {
        switch (highestStatusAccess) {
            case 'draft':
                return ['draft'];
            case 'pending_approval':
                return ['draft', 'pending_approval'];
            case 'ready':
                return ['draft', 'pending_approval', 'ready'];
            default:
                return [];
        }
    };

    getItems = () => {
        const { record, openShareModal, openEmailDrawer, type, settings, formDesigns } = this.props;

        const option = getOptions(type);
        const {id} = record;

        const items = [];
        if (option.view) {
            items.push({
                key: 'view',
                label: t`View`,
                url: TransactionUrl.view(type, id),
            });
        }

        // Add Payment / Refund
        if (option.addPayment && record.balance > 0 && record.status === 'ready') {
            switch (type) {
                case Type.sale_invoice:
                case Type.opening_invoice:
                    this.addPaymentsRefunds(Type.sale_payment, type, id, items);
                    break;
                case Type.purchase_bill:
                case Type.opening_bill:
                    this.addPaymentsRefunds(Type.purchase_payment, type, id, items);
                    break;
                case Type.sale_credit_note:
                case Type.sale_payment:
                case Type.opening_sale_credit_note:
                    this.addPaymentsRefunds(Type.sale_refund, type, id, items);
                    break;
                case Type.purchase_credit_note:
                case Type.purchase_payment:
                case Type.opening_purchase_credit_note:
                    this.addPaymentsRefunds(Type.purchase_refund, type, id, items);
                    break;
                default:
                    break;
            }
        }

        const disableTransferTo = record.transfer_status === 'TRANSFERRED';

        const transferTo = [];
        const copyTo = [];
        const copyItemsTo = [];

        if (option.transferToOrder) {
            transferTo.push({
                key: 'transferToOrder',
                label: getMsgTypeCapitalized(Type.sale_order),
                disabled: disableTransferTo,
                url: TransactionUrl.transfer(Type.sale_order, type, id),
            });
        }

        if (option.transferToDeliveryOrder) {
            transferTo.push({
                key: 'transferToDeliveryOrder',
                label: getMsgTypeCapitalized(Type.sale_delivery_order),
                disabled: disableTransferTo,
                url: TransactionUrl.transfer(Type.sale_delivery_order, type, id),
            });
        }
        if (option.transferToInvoice) {
            transferTo.push({
                key: 'transferToInvoice',
                label: getMsgTypeCapitalized(Type.sale_invoice),
                disabled: disableTransferTo,
                url: TransactionUrl.transfer(Type.sale_invoice, type, id),
            });
        }

        if (option.transferToGoodsReceivedNote) {
            transferTo.push({
                key: 'transferToGoodsReceivedNote',
                label: getMsgTypeCapitalized(Type.purchase_goods_received_note),
                disabled: disableTransferTo,
                url: TransactionUrl.transfer(Type.purchase_goods_received_note, type, id),
            });
        }

        if (option.copyToSaleCreditNote) {
            copyTo.push({
                key: 'copyToSaleCreditNote',
                label: getMsgTypeCapitalized(Type.sale_credit_note),
                url: TransactionUrl.copy(Type.sale_credit_note, type, id),
            });
        }

        if (option.copyItemsToPurchaseOrder) {
            copyItemsTo.push({
                key: 'copyItemsToPurchaseOrder',
                label: getMsgTypeCapitalized(Type.purchase_order),
                url: TransactionUrl.copy_items(Type.purchase_order, type, id),
            });
        }
        if (option.copyItemsToGoodsReceivedNote) {
            copyItemsTo.push({
                key: 'copyItemsToGoodsReceivedNote',
                label: getMsgTypeCapitalized(Type.purchase_goods_received_note),
                url: TransactionUrl.copy_items(Type.purchase_goods_received_note, type, id),
            });
        }

        if (option.transferToBill) {
            transferTo.push({
                key: 'transferToBill',
                label: getMsgTypeCapitalized(Type.purchase_bill),
                disabled: disableTransferTo,
                url: TransactionUrl.transfer(Type.purchase_bill, type, id),
            });
        }
        if (option.copyItemsToBill) {
            copyItemsTo.push({
                key: 'copyItemsToBill',
                label: getMsgTypeCapitalized(Type.purchase_bill),
                url: TransactionUrl.copy_items(Type.purchase_bill, type, id),
            });
        }

        if (option.copyToPurchaseCreditNote) {
            copyTo.push({
                key: 'copyToPurchaseCreditNote',
                label: getMsgTypeCapitalized(Type.purchase_credit_note),
                url: TransactionUrl.copy(Type.purchase_credit_note, type, id),
            });
        }

        // if there are 'Transfer to...' options, and record isn't voided, push it into items
        if (transferTo.length > 0 && record.status !== "void") {
            // Filter only those with permission
            const transferToWithPermission = transferTo.filter(({url}) => {
                const access = PermissionSubscriptionCheck.withUrl(url).hasPermissionTo(PermissionV2.create);
                return access.allowed;
            });

            if (transferToWithPermission.length > 0 && record.status === 'ready') {
                items.push({
                    key: 'transferTo',
                    label: t`Transfer to...`,
                    submenu: transferToWithPermission,
                    subscription: SubscriptionScopeKey["TRANSACTION.ITEM_TRANSFER"],
                });
            }
        }

        // if there are 'Copy to...' options, push it into items
        if (copyTo.length > 0) {
            // Filter only those with permission
            const copyToWithPermission = copyTo.filter(({url}) => {
                const access = PermissionSubscriptionCheck.withUrl(url).hasPermissionTo(PermissionV2.create);
                return access.allowed;
            });

            if (copyToWithPermission.length > 0) {
                items.push({
                    key: 'copyTo',
                    label: t`Copy to...`,
                    submenu: copyToWithPermission,
                });
            }
        }

        // if there are 'Copy to...' options, push it into items
        if (copyItemsTo.length > 0) {
            // Filter only those with permission
            const copyItemsToToWithPermission = copyItemsTo.filter(({url}) => {
                const access = PermissionSubscriptionCheck.withUrl(url).hasPermissionTo(PermissionV2.create);
                return access.allowed;
            });

            if (copyItemsToToWithPermission.length > 0) {
                items.push({
                    key: 'copyItemsTo',
                    label: t`Copy Items to...`,
                    submenu: copyItemsToToWithPermission,
                });
            }
        }

        if (option.duplicate) {
            items.push({
                key: 'duplicate',
                label: t`Duplicate`,
                url: TransactionUrl.duplicate(type, id),
                isCreate: true,
            });
        }

        if (option.copyToRecurring) {
            items.push({
                key: 'recurring',
                label: t`Create Recurring`,
                url: TransactionUrl.recurring(type, id),
                isCreate: true,
                subscription: SubscriptionScopeKey["TRANSACTION.INSTRUCTION"],
            });
        }

        if (option.print) {
            const reorderedFormDesigns = getReorderedFormDesign(type, settings, formDesigns);

            const href = getPrintUrl(
                type,
                id,
                null,
                null,
            ); // default

            const showChequeOption = settings.transaction_enable_print_cheque === true &&
                (type === Type.sale_refund || type === Type.purchase_payment || type === Type.bank_expense);
            const hasMoreThanOneFormDesign = (reorderedFormDesigns || formDesigns || []).length > 1;

            // If there's > 1 form design (including cheque), show dropdown
            if (showChequeOption || hasMoreThanOneFormDesign) {
                const children = (reorderedFormDesigns || formDesigns || []).map((item, index) => ({
                    key: item.id,
                    // label: index === 0 ? AccessHelper.getFormLabel(t`${item.name} (Default)`, false) : // default is never locked
                    // AccessHelper.getFormLabel(item.name, !this.hasMultiFormDesignSubscription),
                    label: index === 0 ? AccessHelper.getFormLabel(t`${item.name} (Default)`) : // default is never locked
                        AccessHelper.getFormLabel(item.name),
                    url: `${href}?form_design_id=${item.id}`,
                    blank: true,
                    appendTokens: true,
                // disabled: index !== 0 && !this.hasMultiFormDesignSubscription,
                }));

                // add print cheque option
                if (showChequeOption) {
                    const chequeOption = {
                        key: 'cheque',
                        label: t`Cheque`,
                        url: `${href}?is_cheque=1`,
                        blank: true,
                        appendTokens: true,
                        disabled: record.amount < 0,
                    };

                    // if (this.hasMultiFormDesignSubscription)
                    children.push(chequeOption); // append at last
                    // else
                    //     children.splice(1, 0, chequeOption); // others are locked, insert after default form design
                }

                items.push({
                    key: 'print',
                    label: t`Print / PDF`,
                    submenu: children,
                });
            }
            // Only one form design, don't show dropdown
            else {
                items.push({
                    key: 'print',
                    label: t`Print / PDF`,
                    url: `${href}`, // default form design id for the transaction will be handled by backend
                    blank: true,
                    appendTokens: true,
                });
            }
        }

        const quickShareSubmenu = [];

        if (openEmailDrawer && option.sendEmail) {
            quickShareSubmenu.push({
                key: 'quickShareEmail',
                label: t`via Email`,
                action: () => openEmailDrawer(record),
                subscription: SubscriptionScopeKey['TRANSACTION.QUICKSHARE'],
                isCreate: true,
            });
        }
        if (openShareModal && option.share) {
            quickShareSubmenu.push({
                key: 'quickShareLink',
                label: t`via Link`,
                action: () => openShareModal(record),
                subscription: SubscriptionScopeKey['TRANSACTION.QUICKSHARE'],
            });
        }

        if (quickShareSubmenu.length) {
            items.push({
                key: 'quickShare',
                label: t`QuickShare...`,
                submenu: quickShareSubmenu,
                subscription: SubscriptionScopeKey['TRANSACTION.QUICKSHARE'],
            });
        }

        if (option.status) {
            const highestStatusAccess = getTransactionInitStatus();

            let children = [];
            const trxStatus = record.status;

            const applicableUpdateStatus = this.getApplicableUpdateStatuses(highestStatusAccess);

            switch (trxStatus) {
                case 'draft': {
                    if (applicableUpdateStatus.includes('pending_approval')) {
                        children.push({
                            key: 'pending_approval',
                            label: t`Pending Approval`,
                            action: () => this.updateTransactionStatus(id, 'pending_approval'),
                            isUpdate: true,
                        });
                    }

                    if (applicableUpdateStatus.includes('ready')) {
                        children.push({
                            key: 'ready',
                            label: t`Ready`,
                            action: () => this.updateTransactionStatus(id, 'ready'),
                            isUpdate: true,
                        });
                    }
                    break;
                }
                case 'pending_approval':
                    children = [
                        ...applicableUpdateStatus.includes('ready') ? [{
                            key: 'ready',
                            label: t`Ready`,
                            action: () => this.updateTransactionStatus(id, 'ready'),
                            isUpdate: true,
                        }] : [],
                    ];
                    break;
                case 'ready':
                default:
                    children = [];
                    break;
            }

            if (children.length) {
                items.push({
                    key: 'updateStatus',
                    label: t`Mark as...`,
                    submenu: children,
                });
            }
        }

        if (option.status) {
            const highestStatusAccess = getTransactionInitStatus();
            switch (record.status) {
                case 'ready':
                    if (highestStatusAccess === 'ready') {
                        // Check if the txn has linked items
                        let hasLinkedItems = false;

                        switch (type) {
                            case Type.sale_invoice:
                                // If balance !== amount && is credit sales, means got linked payments/CN
                                // Else if balance !== amount && is cash sales, means NO linked items
                                // Balance === amount, means no linked payments/CN applied
                                if (record.amount !== 0 && record.balance !== record.amount && record.payment_mode === 'credit')
                                    hasLinkedItems = true;
                                break;
                            case Type.purchase_bill:
                                if (record.amount !== 0 && record.balance !== record.amount && record.payment_mode !== 'cash') // 'credit' or 'claim'
                                    hasLinkedItems = true;
                                break;
                            case Type.sale_credit_note:
                            case Type.purchase_credit_note:
                                // Void always allow on downstream. Example:
                                // IV applied to CN: IV cannot be voided, CN can;
                                // CN applied to Refund: IV and CN cannot be voided, Refund can;
                                // But we can't determine if CN is applied/linked to any refund for now for list menu, so always allow void in frontend and let backend block
                                hasLinkedItems = false;
                                break;
                            default:
                                break;
                        }

                        const {
                            transactionAllowVoid, transactionDisableVoidMsg,
                        } = MyInvoisTransactionHelper.getShouldVoidTransactionDetails(
                            record,
                            !hasLinkedItems,
                        );

                        items.push({
                            key: 'void',
                            label: t`Void`,
                            disabled: (
                                record.transfer_status === 'TRANSFERRED' ||
                            record.transfer_status === 'PARTIAL_TRANSFERRED' ||
                            !transactionAllowVoid
                            ),
                            action: () => this.voidTransaction(id),
                            isUpdate: true,
                            disabledTooltipText: !transactionAllowVoid ? transactionDisableVoidMsg || t`Cannot be voided.` : null,
                        });
                    }
                    break;
                case 'void':
                    if (highestStatusAccess === 'ready') {
                        const {
                            transactionAllowUnvoid, transactionDisableUnvoidMsg,
                        } = MyInvoisTransactionHelper.getAllowUnvoidTransactionDetails(record);

                        items.push({
                            key: 'unvoid',
                            label: t`Unvoid`,
                            action: () => this.unvoidTransaction(id),
                            isUpdate: true,
                            disabled: !transactionAllowUnvoid,
                            disabledTooltipText: !transactionAllowUnvoid ? transactionDisableUnvoidMsg || t`Cannot be unvoided.` : null,
                        });
                        items.push({
                            key: 'delete',
                            label: t`Delete`,
                            action: () => this.deleteTransaction(id),
                            isDelete: true,
                        });
                    }
                    break;
                case 'pending_approval':
                    if (this.getApplicableUpdateStatuses(highestStatusAccess).includes('pending_approval')) {
                        items.push({
                            key: 'delete',
                            label: t`Delete`,
                            action: () => this.deleteTransaction(id),
                            isDelete: true,
                        });
                    }
                    break;
                case 'draft':
                default:
                    if (this.getApplicableUpdateStatuses(highestStatusAccess).includes('draft')) {
                        items.push({
                            key: 'delete',
                            label: t`Delete`,
                            action: () => this.deleteTransaction(id),
                            isDelete: true,
                        });
                    }
                    break;
            }
        }

        // store the row's record id and action items
        this.rowItem = {id, items};

        return items;
    };

    render() {
        return <ListMenu items={this.getItems()} />;
    }
}

export default connect(state => ({
    companyCountryCode: state.Auth.companyCountryCode,
    formDesigns: state.List.formDesigns,
    settings: state.List.settings,
    transactionTableOnRowClickId: state.Transaction.transactionTableOnRowClickId || null,
    transactionTableListMenuClickKey: state.Transaction.transactionTableListMenuClickKey || null,
    history: state.Transaction.history || null,
    transactionTableOpenNewTab: state.Transaction.transactionTableOpenNewTab || false,
}), {
    transactionUpdateStatus,
    transactionDelete,
    transactionTableOnRowClick,
    transactionTableAfterRowClick,
})(withI18n()(TransactionListMenu));
